import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Pencil, Trash } from "lucide-react";
import type { Filter } from "@/types/dataset";

interface FilterListProps {
  filters: Filter[] | undefined;
  onDeleteFilter: (id: string) => void;
  onEditFilter: (filter: Filter) => void;
}

export const FilterList = ({ filters, onDeleteFilter, onEditFilter }: FilterListProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead className="w-[100px]">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {filters?.map((filter) => (
          <TableRow key={filter.id}>
            <TableCell>{filter.name}</TableCell>
            <TableCell>
              <div className="flex gap-2">
                <Button variant="outline" size="icon" onClick={() => onEditFilter(filter)}>
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button variant="destructive" size="icon" onClick={() => onDeleteFilter(filter.id)}>
                  <Trash className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
